<template>
    <div class="view">
        <h2>Rechercher un marché</h2>

        <b-form @submit="onSubmit" @reset="onReset" v-if="show">

            <b-col cols="10">

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-reference" label="Référence" label-for="input-reference">
                            <b-form-input
                                    id="input-reference"
                                    v-model="marche.reference"
                                    type="text"
                                    maxlength="50"
                                    :trim="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-ligne" label="Ligne de métro" label-for="input-ligne">
                            <b-form-select
                                    id="input-ligne"
                                    v-model="marche.ligne"
                                    :options="lignes">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner une ligne
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-typeMarche" label="Type" label-for="input-typeMarche">
                            <b-form-select
                                    id="input-typeMarche"
                                    v-model="marche.typeMarche"
                                    :options="typesMarche">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner un type
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-libelleCourt"
                                      label="Libellé court" label-for="input-libelleCourt">
                            <b-form-input
                                    id="input-libelleCourt"
                                    v-model="marche.libelleCourt"
                                    type="text"
                                    maxlength="20"
                                    :trim="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-libelleLong"
                                      label="Libellé long" label-for="input-libelleLong">
                            <b-form-input
                                    id="input-libelleLong"
                                    v-model="marche.libelleLong"
                                    type="text"
                                    maxlength="200"
                                    :trim="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-groupement"
                                      label="Titulaire / groupement" label-for="input-groupement">
                            <b-form-input
                                    id="input-groupement"
                                    v-model="marche.groupement"
                                    type="text"
                                    maxlength="100"
                                    :trim="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-titulaire"
                                      label="SIREN du titulaire ou mandataire" label-for="input-titulaire">
                            <b-form-input
                                    id="input-titulaire"
                                    v-model="marche.titulaire"
                                    type="text"
                                    maxlength="100"
                                    :formatter="formatSiretSiren"
                                    :trim="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                     <b-col cols="6">
                        <b-form-group id="input-group-territoire" label="Territoire"
                                      label-for="input-territoire">
                            <b-form-select
                                    id="input-territoire"
                                    v-model="marche.territoire"
                                    :options="territoires"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-secteurGeographique" label="Secteur géographique"
                                      label-for="input-secteurGeographique">
                            <b-form-select
                                    id="input-secteurGeographique"
                                    v-model="marche.secteurGeographique"
                                    :options="secteursGeographiques"
                            ></b-form-select>
                            <b-tooltip target="input-group-secteurGeographique"  placement="top" custom-class="tooltip-image">
                                <b-row class="pt-1"><b-col>Merci de déterminer l'arc géographique de référence selon la répartition suivante :</b-col></b-row>
                                <b-row class="pt-1"><b-img :src="require('../../../public/sectorisation_geographique.png')"></b-img></b-row>
                            </b-tooltip>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-group-statut" label="En cours / terminé / à venir (en fonction des dates prévisionnelles)"
                                      label-for="input-statut">
                            <b-form-select
                                    id="input-statut"
                                    v-model="statut">
                                <b-form-select-option :value="null">
                                    Tous
                                </b-form-select-option>
                                <b-form-select-option :value="'en cours'">
                                    En cours
                                </b-form-select-option>
                                <b-form-select-option :value="'termine'">
                                    Terminé
                                </b-form-select-option>
                                <b-form-select-option :value="'a venir'">
                                    À venir
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-termine" label="En cours / terminé"
                                      label-for="input-termine">
                            <b-form-select
                                    id="input-termine"
                                    v-model="marche.termine">
                                <b-form-select-option :value="null">
                                    Tous
                                </b-form-select-option>
                                <b-form-select-option :value="false">
                                    En cours
                                </b-form-select-option>
                                <b-form-select-option :value="true">
                                    Terminé
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-button type="submit" variant="primary">Soumettre</b-button>
                <b-button type="reset" variant="danger">Réinitialiser</b-button>

            </b-col>

        </b-form>

        <div v-if="formSubmitted" class="pt-5">

            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                                v-model="pageSize"
                                :options="pageSizes"
                                @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                                v-model="pageIndex"
                                :total-rows="marchesResult.totalElements"
                                :per-page="pageSize"
                                :limit="10"
                                align="center"
                                @input="search()"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="marchesTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                        </div>
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" @click="editMarche(row.item.id)">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                    </template>
                    <template v-slot:cell(delete)="row">
                        <b-button size="sm" v-b-modal="'modal-delete' + row.item.id">
                            <Icon icon="trash" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-delete' + row.item.id"
                                title="Suppression de marché"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="deleteMarche(row.item.id)">
                            <p>Confirmez-vous la suppression de ce marché ?</p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>

    </div>
</template>

<script>

  import MarcheDto from "../../dtos/MarcheDto";
  import LigneStore from "../../stores/LigneStore";
  import TypeMarcheStore from "../../stores/TypeMarcheStore";
  import MarcheStore from "../../stores/MarcheStore";
  import AlertStore from "../../stores/AlertStore";
  import formatSiretSiren from "../../filters/formatSiretSiren";
  import {SecteurGeographiqueEnum} from "../../constants/enums";
  import TerritoireStore from "../../stores/TerritoireStore";

  export default {
    data() {
      return {
        formSubmitted: false,
        marche: new MarcheDto(),
        marchesResult: null,
        show: true,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        lignes: [],
        typesMarche: [],
        statut: null,
        secteursGeographiques: Object.entries(SecteurGeographiqueEnum).map(value => {
          return {text: value[1], value: value[0]}
        }),
        fields: [
          {label: '', key: 'num', sortable: false},
          {label: 'Référence', key: 'reference', sortable: true},
          {label: 'Libellé', key: 'libelleCourt', sortable: true},
          {label: 'Type', key: 'typeMarche', sortable: true},
          {label: 'Consulter / Modifier', key: 'edit', sortable: false},
          {label: 'Supprimer', key: 'delete', sortable: false}
        ],
        territoires: []
      }
    },
    computed: {
      marchesTable: function () {
        return this.marchesResult.content.map(marche => {
          return {
            id: marche.id,
            reference: marche.reference,
            libelleCourt: marche.libelleCourt,
            typeMarche: marche.typeMarche.libelle
          }
        });
      }
    },

    mounted() {
      this.initPagination();

      LigneStore.getAll().then(
          response => {
            this.lignes = response.map(value => {
              return {text: value.libelleLong, value: value.id};
            });
          }
      );
      TypeMarcheStore.getAll().then(
          response => {
            this.typesMarche = response.map(value => {
              return {text: value.libelle, value: value.id};
            });
          }
      );
      TerritoireStore.getAll().then(
          response => this.territoires = response.map(value => {
            return {text: value.libelle, value: value.id};
          })
      );
    },
    methods: {
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        this.sortOptions = [{sortBy: 'reference', sortDirection: 'asc'}];
      },
      formatSiretSiren(value) {
        return formatSiretSiren(value);
      },
      search() {
        MarcheStore.search(this.marche, this.statut, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.marchesResult = result.data;
              this.formSubmitted = true;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      editMarche(id) {
        this.$router.push("/marches/" + id);
      },
      deleteMarche(id) {
        MarcheStore.delete(id).then(() => {
          this.search();
        });
      },
      onSubmit(evt) {
        evt.preventDefault();
        this.initPagination();
        this.search();
      },
      onReset(evt) {
        evt.preventDefault();
        this.marche = new MarcheDto();
        this.formSubmitted = false;
        this.show = false;
        this.$nextTick(() => {
          this.show = true
        })
      },
    }

  }
</script>

